class RegionsGrowthActions {
    static REGIONS_GROWTH_REQUEST = "REGIONS_GROWTH_REQUEST";
    static REGIONS_GROWTH_SUCCESSFUL = "REGIONS_GROWTH_SUCCESSFUL";
    static REGIONS_GROWTH_FAILED = "REGIONS_GROWTH_FAILED";

    static regionsGrowthRequest() {
        return {
            type: this.REGIONS_GROWTH_REQUEST
        };
    }
    static regionsGrowthSuccessul(data) {
        // console.log(data,"channel action")
        return {
            type: this.REGIONS_GROWTH_SUCCESSFUL,
            data
        };
    }
    static regionsGrowthFailed(error) {
        return {
            type: this.REGIONS_GROWTH_FAILED,
            error
        };
    }
}

export default RegionsGrowthActions;
